export default __webpack_public_path__ + "static/in-memoriam-banner-bg-8b7c6be86699f923c0a9e539f6b82bd3.jpg";